import { lazy } from 'react';

/** Загружает страницу шаблонов уведомлений */
export const NotificationTemplatesPageAsync = lazy(
    () => import('./NotificationTemplates/NotificationTemplatesPage'),
);
